export const isBase64DataURL = (str) => {
  if (typeof str !== 'string') {
    return false;
  }

  const dataUrlRegex = /^data:image\/[a-zA-Z]+;base64,[A-Za-z0-9+/]+={0,2}$/;

  if (!dataUrlRegex.test(str)) {
    return false;
  }

  try {
    const base64String = str.split(',')[1];

    return btoa(atob(base64String)) === base64String;
  } catch (err) {
    return false;
  }
}
